function fireAnalyticsEvent(name, data, isAgent) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: name,
    user_type: isAgent ? 'agent' : 'consumer',
    ...(data || {}),
  })
}

export default fireAnalyticsEvent

export const formatHotelsForAnalytics = (cart) =>
  cart?.itineraryInfo?.reservationItems?.item
    ?.filter((item) => !!item.hotel)
    ?.map(({ hotel, rph }) => {
      const { roomStays } = hotel
      const pricingData = cart?.itineraryPricing?.find(
        ({ associatedItemRPH }) => associatedItemRPH === rph
      )
      return {
        ...(roomStays || {}),
        ...(pricingData?.cost || {}),
      }
    })
